export default "__VITE_ASSET__53604f8e__"